import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useParams } from "react-router-dom";
import SingleTicketCard from "./SingleTicketCard";
import TicketComment from "./TicketComment";
import SideNav from "../../../../agentComponents/sidenav";
import { useFormik } from "formik";
import apiEndPointsConfig from "../../../../services/apiEndPoints";
import axiosInstance from "../../../../services/axiosInstance";

const statuses = [
  "Open",
  "Pending",
  "On-Hold",
  "Resolved",
  "Waiting On Customer",
  "Reopen",
  "Waiting on agent",
];

const SIngleTicket = () => {
  const { id } = useParams();
  const token = localStorage.getItem("token");
  const [ticket, setTicket] = useState([]);
  const agentId = localStorage.getItem("agentId");

  useEffect(() => {
    getSingleTicket();
  }, []);

  const getSingleTicket = async () => {
    const res = await axiosInstance.get(`${apiEndPointsConfig.agentTicketById}/${id}`);
    setTicket(res.data.data);
  };

  const chnageTicketStatus = async (values) => {
    const data = {
      ticketId: id,
      status: values,
    };
    const res = await axiosInstance.post(
      `${apiEndPointsConfig.changeTicketStatus}`,
      data
    );
  };

  const formik = useFormik({
    initialValues: {
      status: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("Submitted values:", values);
      chnageTicketStatus(values?.status);
    },
  });
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          p: {
            xs: "50px 0 0 0",
            md: "100px 20px",
          },
          bgcolor: "white",
        }}
      >
        <SideNav />
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1rem",
                  mb: 2,
                  color: "#424242",
                }}
              >
                <span
                  style={{
                    fontWeight: 900,
                  }}
                >
                  Ticket Number :
                </span>{" "}
                {ticket?._id}
              </Typography>
              <Typography
                sx={{
                  fontSize: "1rem",
                  mb: 2,
                  ml: "50px",
                  color: "#424242",
                }}
              >
                <span
                  style={{
                    fontWeight: 900,
                  }}
                >
                  Call Time :
                </span>{" "}
                {ticket?.createdAt}
              </Typography>
            </Box>

            <Box>
              <Autocomplete
                disableClearable
                id="status"
                options={statuses}
                value={formik.values.status || ticket?.status || ""}
                onChange={(event, value) => {
                  formik.setFieldValue("status", value);
                  formik.submitForm();
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Status"
                    variant="outlined"
                    sx={{
                      width: 250,
                      "& .MuiOutlinedInput-root": {
                        padding: "10px",
                        height: "40px",
                        borderRadius: "8px",
                        "&.Mui-focused": {
                          borderColor: "#1976d2",
                        },
                      },
                    }}
                    error={Boolean(
                      formik.errors.status && formik.touched.status
                    )}
                    helperText={formik.touched.status && formik.errors.status}
                  />
                )}
              />
            </Box>
          </Box>

          <SingleTicketCard ticket={ticket} />
          <Box
            sx={{
              bgcolor: "white",

              overflowX: "auto",
              mt: 4,
            }}
          >
            <TableContainer>
              <Table
                sx={{
                  minWidth: 650,
                  bgcolor: "white", // Background color for the table
                  borderCollapse: "collapse", // Ensure borders collapse
                }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ border: "1px solid grey" }}>ID</TableCell>

                    <TableCell sx={{ border: "1px solid grey" }}>
                      Title
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      Description
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      Status
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      TicketType
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      CreateDate
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={ticket}>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?._id}
                    </TableCell>

                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?.title}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?.issue}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?.status}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?.category}
                    </TableCell>
                    <TableCell sx={{ border: "1px solid grey" }}>
                      {ticket?.createdAt}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <TicketComment ticket={ticket} />
        </Box>
      </Box>
    </div>
  );
};

export default SIngleTicket;
